import { useQuery } from '@tanstack/react-query'
import { useAuth } from './useAuth'
import { societyQueries } from '../api/societies'

export const useBlockedSocietyIds = (): void => {
  const { userId } = useAuth()
  // Fetch when started if authenticated
  useQuery({ ...societyQueries.getUserBlockedSocietyIds(), enabled: !!userId })
}
